import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import styles from './venueLogo.styles';
import { images } from '../../themes/variables';
const Img = styled.img `
  ${styles}
`;
const VenueLogo = ({ logo, maxHeight = 42, maxWidth = 175, smallerOnMobile = false }) => {
    const venueLogo = logo ? logo : images.playerCredit;
    return _jsx(Img, { src: venueLogo, maxHeight: maxHeight, maxWidth: maxWidth, smallerOnMobile: smallerOnMobile });
};
export default VenueLogo;
